export default __webpack_public_path__ + "static/media/dispenser preform.jpg.91ba8c74.webp";